function parseColorToRgb(color) {
  const raw = String(color ?? '').trim();
  if (!raw) return null;

  const hexMatch = raw.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hexMatch) {
    const normalized = hexMatch[1].length === 3
      ? hexMatch[1].split('').map((part) => `${part}${part}`).join('')
      : hexMatch[1];

    return {
      red: Number.parseInt(normalized.slice(0, 2), 16),
      green: Number.parseInt(normalized.slice(2, 4), 16),
      blue: Number.parseInt(normalized.slice(4, 6), 16),
    };
  }

  const rgbMatch = raw.match(/^rgba?\(([^)]+)\)$/i);
  if (rgbMatch) {
    const parts = rgbMatch[1].split(',').map((part) => Number.parseFloat(part.trim()));
    if (parts.length >= 3 && parts.every((part, index) => index < 3 ? Number.isFinite(part) : true)) {
      return {
        red: parts[0],
        green: parts[1],
        blue: parts[2],
      };
    }
  }

  return null;
}

function toLinearChannel(value) {
  const normalized = value / 255;
  if (normalized <= 0.03928) {
    return normalized / 12.92;
  }
  return ((normalized + 0.055) / 1.055) ** 2.4;
}

export function getReadableTextColor(backgroundColor) {
  const rgb = parseColorToRgb(backgroundColor);
  if (!rgb) return '#111827';

  const luminance = (
    0.2126 * toLinearChannel(rgb.red) +
    0.7152 * toLinearChannel(rgb.green) +
    0.0722 * toLinearChannel(rgb.blue)
  );

  return luminance > 0.45 ? '#111827' : '#f2f4f6';
}

export function getContrastDividerColor(backgroundColor, { strong = false } = {}) {
  const textColor = getReadableTextColor(backgroundColor);
  return textColor === '#f2f4f6'
    ? `rgba(242, 244, 246, ${strong ? 0.32 : 0.18})`
    : `rgba(17, 24, 39, ${strong ? 0.38 : 0.22})`;
}

export function colorWithAlpha(color, alpha, fallback = `rgba(255, 255, 255, ${alpha})`) {
  const rgb = parseColorToRgb(color);
  if (!rgb) return fallback;
  return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${alpha})`;
}
